import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import NetworksBody from './NetworksBody';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import NetworkProvider from './context/NetworkProvider';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const Networks = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <NetworkProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="CNMAESTRO - Networks" position={firstName} />
          <NetworksBody />
        </main>
        <ToastContainer />
      </NetworkProvider>
    </div>
  );
};

export default Networks;
